exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-wrapper[data-v-1a32d61a] {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  border-radius: 20px;\n  padding: 15px;\n}\n.card-wrapper__title-container[data-v-1a32d61a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.card-wrapper__title[data-v-1a32d61a] {\n    font-size: 24px;\n    font-weight: 400;\n    color: #2C3030;\n    line-height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a32d61a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/UI/CardWrapper.vue
// module id = i/gU
// module chunks = 1